import { IndeedGeneralException } from './IndeedGeneralException';

export class IndeedCandidateSubscriptionMismatchException extends IndeedGeneralException {
  constructor(message: string) {
    super(message);
  }
}
